import { SearchIcon, XIcon } from 'lucide-react';
import { useEffect, useState } from 'react';
import { useDebounce } from 'react-use';
import { Input } from '../ui/input';

type Props = {
    value: string;
    onChange: (value: string) => void;
    placeholder?: string;
    className?: string;
    inputClassName?: string;
};

export const CancellableSearchBox: React.FC<Props> = ({
    placeholder = '',
    value: initialValue = '',
    onChange,
    className,
}) => {
    const [searchBoxText, setSearchBoxText] = useState(initialValue);

    // Only sync when value is cleared externally (e.g., Clear filters button)
    useEffect(() => {
        if (!initialValue) {
            setSearchBoxText('');
        }
    }, [initialValue]);

    const onCancel = () => {
        setSearchBoxText('');
    };

    const showCancel = searchBoxText.length > 0;

    useDebounce(
        () => {
            onChange(searchBoxText);
        },
        500,
        [searchBoxText],
    );

    return (
        <Input
            leftIcon={SearchIcon}
            rightIcon={showCancel ? XIcon : undefined}
            onRightIconClick={
                showCancel
                    ? () => {
                          onCancel();
                      }
                    : undefined
            }
            placeholder={placeholder}
            value={searchBoxText}
            onChange={(e) => {
                setSearchBoxText(e.target.value);
            }}
            className={className}
        />
    );
};
